export default function clearCacheReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'CLEAR_CACHE_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'CLEAR_CACHE_ERROR':
            return {...state, ...{error: action.error}};

        case 'CLEAR_CACHE_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}